import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';
import { InterviewResult } from '@core/interview-results-types';

export type EvaluationFormState = Pick<
  InterviewResult,
  'kind' | 'rating' | 'ratingNote' | 'offerId' | 'stageId' | 'createdAt'
>;

@Injectable()
export class QuickEvaluationCacheService {
  private readonly cachePrefix = 'QUICK_EVALUATION_FORM';

  private readonly localStorage = inject(LocalStorageService);

  public getValue(interviewResultId: InterviewResult['id']): EvaluationFormState | null {
    const value = this.localStorage.get(`${this.cachePrefix}_${interviewResultId}`, null);
    return value === 'null' ? null : value;
  }

  public setValue(interviewResultId: InterviewResult['id'], state: EvaluationFormState): void {
    this.localStorage.set(`${this.cachePrefix}_${interviewResultId}`, {
      ...state,
      createdAt: new Date().toISOString(),
    });
  }

  public deleteValue(interviewResultId: InterviewResult['id']): void {
    this.localStorage.remove(`${this.cachePrefix}_${interviewResultId}`);
  }
}
